<template>
  <page>
    <div class="m-grid__item m-grid__item--fluid m-wrapper">
      <div class="m-subheader d-flex">
        <div class="d-flex align-items-center">
          <div v-if="rewardsCategoriesAsGrid && category" class="mr-4">
            <button class="btn btn-sm m-btn m-btn--pill m-btn--custom btn-outline-ls"
                    @click="clearSelectedCategory">Wróć
            </button>
          </div>
          <h1 v-if="!rewardsCategoriesAsGrid || !category" v-encode="pageTitle" class="m-subheader__title m-subheader__title--separator"></h1>
          <h1 v-else  class="m-subheader__title m-subheader__title--separator">{{ categoryName }}</h1>
        </div>
        <div class="d-flex align-items-center flex-md-row flex-grow-1"
             :class="[showCategoriesSelect && 'flex-column-reverse']">
          <input type="text" :class="rewardsCategoriesAsGrid ? 'form-control m--hidden-mobile mr-3 max-width-215 categories-search-bar' : 'form-control m--hidden-mobile mr-3 max-width-215 rewards-search-bar'" placeholder="Znajdź"
                 v-model="nameFilter">
          <div v-if="showCategoriesSelect" v-click-outside="closeCategoryDropdown"
               class="m-dropdown m-dropdown--inline m-dropdown--align-right ml-auto ml-md-2 mr-0 mr-md-2"
               :class="{'m-dropdown--open': categoryDropdownOpen}" aria-expanded="true">
            <a href="#" class="m-dropdown__toggle btn-secondary btn dropdown-toggle"
               @click="toggleCategoryDropdown">
              {{ categoryName }}
            </a>
            <div class="m-dropdown__wrapper width-315" style="z-index: 2;">
              <span class="m-dropdown__arrow m-dropdown__arrow--right"></span>
              <div class="m-dropdown__inner">
                <div class="m-dropdown__body">
                  <div class="m-dropdown__content">
                    <ul class="m-nav">
                      <li v-for="category in categories" :key="category.id" class="m-nav__item m-nav__item-ls">
                        <a href="#" class="m-nav__link" @click="setCategory(category.id)">
                          <span class="m-nav__link-text">{{ category.name }}</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row m--visible-mobile mt-3 mx-2">
        <div class="col">
          <input class="form-control m-input" type="text" placeholder="Znajdź" v-model="nameFilter">
        </div>
      </div>
      <div v-if="rewardsCategoriesAsGrid && categoriesFiltered.length && !category" class="m-content pb-0">
        <div class="row">
          <reward-grid-item v-for="category in categoriesFiltered"
                            :category="true"
                            :reward="category"
                            :key="category.id"
                            @select="selectCategory"></reward-grid-item>
        </div>
      </div>
      <div class="m-content" v-if="!rewards.length">
        <div class="m-portlet m-portlet--full-height">
          <div class="m-portlet__body">
            <div class="tab-content">
              <div class="tab-pane active" id="m_widget2_tab1_content" aria-expanded="true">
                Brak nagród
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="rewardsSliced.length > 0" class="m-content">
        <div class="row">
          <reward-grid-item v-for="reward in rewardsSliced" :reward="reward" :key="reward.id"></reward-grid-item>
        </div>
        <div v-if="isThereMore" class="row">
          <div class="col m--align-center">
            <button type="button" class="btn btn-sm m-btn--custom m-btn--pill btn-ls"
                    @click="showMore">Załaduj więcej
            </button>
          </div>
        </div>
      </div>
      <div v-else class="m-content text-center">
        <spinner v-if="isLoading"></spinner>
        <p v-else-if="(!rewardsCategoriesAsGrid || category) && rewards.length">Brak nagród.</p>
      </div>
    </div>
    <order-reward-modal></order-reward-modal>
    <order-digital-reward-modal></order-digital-reward-modal>
    <digital-reward-modal/>
    <material-reward-modal/>
    <variants-reward-modal/>
  </page>
</template>

<script>
import RewardGridItem from "../reward/RewardGridItem";
import Page from "./Page";
import {mapActions, mapState} from 'vuex';
import ClickOutside from 'vue-click-outside'
import Encode from "@/directives/encode";
import Spinner from "../spinner/Spinner";
import OrderRewardModal from "../modal/OrderRewardModal";
import OrderDigitalRewardModal from "../modal/OrderDigitalRewardModal";
import BeforeRoute from "@/mixins/beforeRoute";
import PageTitle from "@/mixins/pageTitle";
import DigitalRewardModal from "@/components/modal/DigitalRewardModal";
import MaterialRewardModal from "@/components/modal/MaterialRewardModal";
import VariantsRewardModal from "../modal/VariantsRewardModal";

export default {
  name: "RewardsPage",
  components: {
    MaterialRewardModal,
    VariantsRewardModal,
    DigitalRewardModal,
    OrderDigitalRewardModal,
    OrderRewardModal,
    Spinner,
    Page,
    RewardGridItem
  },
  directives: {
    ClickOutside,
    Encode
  },
  mixins: [
    BeforeRoute('fetchEntityRewards'),
    PageTitle('Nagrody'),
  ],
  data() {
    return {
      SORTING_DATE_ADD_ASC: 0,
      SORTING_DATE_ADD_DESC: 1,
      SORTING_MISSING_POINTS_ASC: 2,
      SORTING_MISSING_POINTS_DESC: 3,
      SORTING_REQUIRED_POINTS_ASC: 4,
      SORTING_REQUIRED_POINTS_DESC: 5,
      SORTING_NAME_ASC: 6,
      SORTING_NAME_DESC: 7,
      categoryDropdownOpen: false,
      nameFilter: '',
      category: 0,
      variant_of: [],
      showOnPage: 0,
      isLoading: false,
    }
  },
  mounted() {
    this.fetchSettings(this.entityUuid).then(() => {
      this.resetShowOnPage()
    });
  },
  methods: {
    ...mapActions([
      'fetchEntityRewards',
      'fetchSettings',
    ]),
    selectCategory(e) {
      this.category = e.category.id;
      this.nameFilter = '';
      this.resetShowOnPage();
    },
    clearSelectedCategory() {
      this.category = 0;
      this.resetShowOnPage();
      this.nameFilter = '';
    },
    toggleCategoryDropdown() {
      this.categoryDropdownOpen = !this.categoryDropdownOpen
    },
    closeCategoryDropdown() {
      if (this.categoryDropdownOpen) {
        this.categoryDropdownOpen = false
      }
    },
    setCategory(category) {
      if (category === 0) {
        this.category = category;
        this.categoryDropdownOpen = false;
        this.resetShowOnPage();
        return;
      }

      if (this.categories) {
        const selectedCategory = this.categories.filter((c) => c.id === category)[0];

        this.isDetailsModalOpen = false;
        let push = { name: 'RewardsByCategoryPage', params: { id: selectedCategory.hid } };

        if (this.returnPage) {
          push.query = {
            return: this.returnPage,
            status: this.returnStatus,
            showOnPage: this.returnShowOnPage
          };
        }
        this.$router.push(push)
      }
    },
    sortAsc(a, b, parse = false) {
      if (parse) {
        a = parseInt(a);
        b = parseInt(b);
      }

      if (a > b)
        return 1;
      if (a < b)
        return -1;
      return 0;
    },
    sortDesc(a, b, parse = false) {
      if (parse) {
        a = parseInt(a);
        b = parseInt(b);
      }

      if (a > b)
        return -1;
      if (a < b)
        return 1;
      return 0;
    },
    showMore() {
      this.showOnPage = this.showOnPage + this.rewardsPerPage;
    },
    resetShowOnPage() {
      this.showOnPage = this.rewardsPerPage;
    }
  },
  computed: {
    ...mapState({
      rewards: state => state.entityRewards.rewards,
      categories: state => state.entityRewards.categories,
      saldo: state => state.auth.user.saldo,
      entityUuid: state => state.auth.entity.uuid,
      sorting: state => state.settings.rewardsCatalogSort,
      rewardsShowVariants: state => state.settings.rewardsShowVariants,
      rewardsPerPage: state => state.settings.rewardsPerPage,
      rewardsCategoriesAsGrid: state => state.settings.rewardsCategoriesAsGrid,
    }),
    categoriesFiltered() {
      if (this.nameFilter.length) {
        return this.categories.filter((c) => c.name.trim().toLowerCase().includes(this.nameFilter.trim().toLowerCase()));
      } else {
        return this.categories.filter((c) => c.id !== 0);
      }
    },
    rewardsFiltered() {
      let filtered = [];

      if (this.nameFilter.length) {
        this.resetShowOnPage();
        filtered = this.rewards.filter((r) => r.name.trim().toLowerCase().includes(this.nameFilter.trim().toLowerCase()))
      } else {
        filtered = this.rewards;
      }

      filtered = filtered.filter((r) => r.type!=="2" || r.variants.length>0)

      if (this.rewardsCategoriesAsGrid && !this.category) {
        filtered = filtered.filter((r) => r.reward_category_id === null);
      }

      if (!this.rewardsShowVariants) {
        filtered = filtered.filter((r) => r.variant_of.length<1);
      }

      return filtered;
    },
    rewardsSorted() {
      let cloneDeep = require('lodash.clonedeep');
      let cloneFiltered = cloneDeep(this.rewardsFiltered);

      switch (this.sorting) {
        case this.SORTING_DATE_ADD_ASC:
          return cloneFiltered.sort((a, b) => this.sortAsc(a.id, b.id, true));
        case this.SORTING_DATE_ADD_DESC:
          return cloneFiltered.sort((a, b) => this.sortDesc(a.id, b.id, true));
        case this.SORTING_MISSING_POINTS_ASC:
          return cloneFiltered.sort((a, b) => {
            let aMissing = parseInt(a.points) - parseInt(this.saldo);
            let bMissing = parseInt(b.points) - parseInt(this.saldo);

            return this.sortAsc(aMissing, bMissing)
          });
        case this.SORTING_MISSING_POINTS_DESC:
          return cloneFiltered.sort((a, b) => {
            let aMissing = parseInt(a.points) - parseInt(this.saldo);
            let bMissing = parseInt(b.points) - parseInt(this.saldo);

            return this.sortDesc(aMissing, bMissing)
          });
        case this.SORTING_REQUIRED_POINTS_ASC:
          return cloneFiltered.sort((a, b) => this.sortAsc(a.points, b.points, true));
        case this.SORTING_REQUIRED_POINTS_DESC:
          return cloneFiltered.sort((a, b) => this.sortDesc(a.points, b.points, true));
        case this.SORTING_NAME_ASC:
          return cloneFiltered.sort((a, b) => this.sortAsc(a.name, b.name));
        case this.SORTING_NAME_DESC:
          return cloneFiltered.sort((a, b) => this.sortDesc(a.name, b.name));
      }
    },
    rewardsCategorized() {
      if (this.category === 0) {
        return this.rewardsSorted;
      }

      return this.rewardsSorted.filter(r => r.reward_category_id === this.category);
    },
    rewardsSliced() {
      return this.rewardsCategorized.slice(0, this.showOnPage)
    },
    isThereMore() {
      return this.showOnPage < this.rewardsCategorized.length;
    },
    categoryName() {
      let category = this.categories.find(category => category.id === this.category);
      return category
          ? category.name
          : null;
    },
    showCategoriesSelect() {
      return this.categories.length > 1 && !this.rewardsCategoriesAsGrid;
    }
  },
}
</script>

<style scoped>
.m-nav .m-nav__item-ls:hover:not(.m-nav__item--disabled) > .m-nav__link .m-nav__link-text {
  color: var(--accent-color) !important;
}

.width-315 {
  width: 315px !important;
}

.max-width-215 {
  max-width: 215px;
}
</style>
